module.exports = __webpack_public_path__ + "img/21.2f56ba8e.png";